module.exports = __webpack_public_path__ + "img/chest-mesomorph-female.b7581fee.svg";